import { Vue, Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';
import IPSDialog from '@/views/components/picker/dialog';
import DialogFactory from '@/views/components/picker/dialogFactory';
import style from '@/views/components/linkForm/style.vue';
import { Functions } from '@/library/utils/functions';
import Socket, { SOCKET_STATUS } from '@/library/socket';
import { appEnvConfig } from '@/configs/appConfigs';
import baseAPIService from '@/services/base/baseAPIService';
import ExportFile from '@/views/components/exportFile';

@DialogFactory
@Component({
  components: {},
  mixins: [style],
})
export default class ChildList extends IPSDialog {
  title = '二级列表';

  dataList = [];

  selected = [];

  footer = false;

  vGuiderId = 0;

  tableLoading = true;

  mounted() {
    this.getData();

    this.$on('socket', (st) => {
      if (st === SOCKET_STATUS.S) {
        this.$emit('download');
      }
    });
  }

  getData() {
    IPSService.guiderSecondList({
      postParams: {
        vGuiderId: this.vGuiderId,
      },
    }).then(
      (response) => {
        this.dataList = response.list;
        this.tableLoading = false;
      },
      () => {
        this.tableLoading = false;
      },
    );
  }

  batchRelieve() {
    const vGuiderIds = this.selected.map(v => v.vGuiderId);
    this.$confirm('确认解除一二级关系？解除后不可恢复！', { type: 'warning' }).then((result) => {
      this.guiderSecondRemove(vGuiderIds);
    });
  }

  onRelieve(vGuiderIds) {
    this.$confirm('确认解除一二级关系？解除后不可恢复！', { type: 'warning' }).then((result) => {
      this.guiderSecondRemove(vGuiderIds);
    });
  }

  guiderSecondRemove(vGuiderIds) {
    this.tableLoading = true;
    IPSService.guiderSecondRemove({
      postParams: {
        vGuiderIds,
      },
    }).then(
      (response) => {
        this.$message.success('解除成功');
        this.getData();
      },
      () => {
        this.tableLoading = false;
      },
    );
  }

  /**
   * 导出列表
   * @return null
   */
  // protected onExportList(): void {
  //   const downloadState = +localStorage.getItem("downloadState");
  //   if (downloadState === 2) {
  //     new Socket(
  //       "adminVGuiderListExport",
  //       {
  //         vGuiderId: this.vGuiderId,
  //       },
  //       "post",
  //     ).setDownloadMsg();
  //     return;
  //   } else {
  //     new Socket(
  //       "adminVGuiderListExport",
  //       {
  //         vGuiderId: this.vGuiderId,
  //       },
  //       "post",
  //     )
  //       .getDownUrl()
  //       .then((res) => {
  //         Socket.download(res);
  //       });
  //   }
  // }

  get exportParams() {
    const postParams = {
      exportType: 'secondExport',
      params: {
        vGuiderId: this.vGuiderId,
      },
    };

    return postParams;
  }

  renderFooter(h) {
    return (
      <div class="bottomWrapper" style="border-top: 1px solid #EBEEF5">
        <div>
          <el-button type="primary" disabled={!this.selected.length} onClick={() => this.batchRelieve()}>
            批量解除
          </el-button>
          <ExportFile class="scopeSpan r-ml-20" export-text="导出" params={this.exportParams} http-type="post" is-button="false" service-url="adminExport">
            导出
          </ExportFile>
        </div>

        <el-button type="primary" onClick={() => this.onCancel()}>
          关闭
        </el-button>
      </div>
    );
  }

  renderContent(h) {
    return (
      <div class="select-list">
        <div class="tableWrapper width-100">
          <el-table
            data={this.dataList}
            height="350px"
            style="width: 100%"
            tooltip-effect="light"
            v-loading={this.tableLoading}
            on-selection-change={(v) => {
              this.selected = v;
            }}>
            <el-table-column type="selection" width="55" />
            <el-table-column type="index" label="ID" width="55" align="center" />
            <el-table-column prop="buyerName" width="100" label="姓名" show-overflow-tooltip {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <span v-encrypt={{ data: scope.row.buyerName, type: 'name' }}> {scope.row.buyerName} </span>
                  );
                },
              },
            }} />
            <el-table-column prop="buyerPhone" width="180" label="手机号" show-overflow-tooltip {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <span v-encrypt={{ data: scope.row.buyerPhone, type: 'phone' }}> {scope.row.buyerPhone}</span>
                  );
                },
              },
            }} />
            <el-table-column
              prop="siteCode"
              width="240"
              label="所属网点"
              show-overflow-tooltip
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return (
                      <div>
                        {`【${scope.row.siteCode}】`}
                        {scope.row.siteName}
                      </div>
                    );
                  },
                },
              }}
            />
            <el-table-column
              prop="buyerPhone"
              width="140"
              label="分销类型"
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <div>{['顾客分销', '员工分销', '导购分销'][scope.row.policyType] || '/'}</div>;
                  },
                },
              }}
            />
            <el-table-column prop="tagName" width="100" label="角色标签" show-overflow-tooltip />
            <el-table-column
              prop=""
              width="140"
              label="操作"
              align="center"
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return (
                      <span class="scopeSpan" onClick={() => this.onRelieve([scope.row.vGuiderId])}>
                        解除一二级关系
                      </span>
                    );
                  },
                },
              }}
            />
          </el-table>
          {this.renderFooter(h)}
        </div>
      </div >
    );
  }
}
